import { groupActions } from '../groups/group-slice';
import { getData } from '../common-actions';
import { fetchGroups } from '../../lib/api';

export const getGroups = (token, signal) => {

  return getData({
    token: token,
    actions: groupActions,
    fetchFn: (token) => fetchGroups(token, signal),
    dataKey: "groups",
    name: "get groups",
    setFunctionName: "setGroups"
  });

  
};
